import { useState, useEffect } from 'react';
import { useUserProfileStore } from '../../store/user';
import { experiencieBagdetProfileView } from '../../types/experiencieBagdet';
import ModalTolltip from '../Modal/Tooltip';

export default function TooltipExpOnClick() {
	const [isOpen, setIsOpen] = useState(false);
	const userData = useUserProfileStore((state) => state.userData);

	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		const handleClickOutside = () => setIsOpen(false);

		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	useEffect(() => {
		if (!isOpen) return;
		const timer = setTimeout(() => {
			setIsOpen(false);
		}, 5000);

		return () => {
			clearTimeout(timer);
		};
	}, [isOpen]);

	return (
		<div className="relative inline-block">
			<button
				onClick={(e: any) => {
					e.stopPropagation();
					handleClick();
				}}
			>
				{userData &&
					experiencieBagdetProfileView(userData.experienceBadget)}
			</button>

			{userData && (
				<ModalTolltip
					id={'modalTooltipExpOn'}
					open={isOpen}
					onClose={handleClick}
					infoIcon={'warning'}
				>
					<h2 className="text-black text-lg font-semibold font-bahnschrift leading-7">
						{userData.experienceBadget === 0
							? 'Seu nível atual é Novato.'
							: 'Seu nível atual é Profissional.'}
					</h2>
					<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
						{userData.experienceBadget === 0
							? 'Participe dos torneios para o seu nível e desenvolva suas habilidades. Quanto mais você participar, mais próximo ficará do nível Profissional!'
							: 'Com esse nível, você pode competir nos torneios mais desafiadores, enfrentando os maiores craques. Mostre sua habilidade e conquiste a vitória!'}
					</p>
				</ModalTolltip>
			)}
		</div>
	);
}
